import { useMutation, useQuery } from "react-query";
import axios from "axios";

const useWorkSection = ({ page }) => {
  const workSectionApi = async () => {
    return await axios.get(`v1/admin/workSection`).then((res) => {
      const data = res.data?.data || [];
      return [...data].sort((a, b) => {
        const ao =
          typeof a?.order === "number" ? a.order : Number.MAX_SAFE_INTEGER;
        const bo =
          typeof b?.order === "number" ? b.order : Number.MAX_SAFE_INTEGER;
        if (ao !== bo) return ao - bo;
        const ad = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
        const bd = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
        return ad - bd;
      });
    });
  };
  const {
    data: workSection,
    isLoading: workSectionLoading,
    refetch: refetchWorkSection,
  } = useQuery("workSection", workSectionApi, {
    enabled: page === "work_section",
  });

  const createWorkSectionApi = async (body) => {
    return await axios
      .post(`/v1/admin/workSection`, body)
      .then((res) => res?.data?.data);
  };
  const { mutate: createWorkSection, isLoading: createWorkSectionLoading } =
    useMutation(createWorkSectionApi);

  const updateWorkSectionApi = async ({ workSectionId, body }) => {
    return await axios
      .put(`/v1/admin/workSection/${workSectionId}`, body)
      .then((res) => res?.data?.data);
  };
  const { mutate: updateWorkSection, isLoading: updateWorkSectionLoading } =
    useMutation(updateWorkSectionApi);

  const deleteWorkSectionApi = async ({ workSectionId, body }) => {
    return await axios
      .delete(`/v1/admin/workSection/${workSectionId}`, body)
      .then((res) => res?.data?.data);
  };
  const { mutate: deleteWorkSection, isLoading: deleteWorkSectionLoading } =
    useMutation(deleteWorkSectionApi);

  const reorderWorkSectionApi = async (orderedIds) => {
    return await axios
      .put(`/v1/admin/workSection/reorder`, { order: orderedIds })
      .then((res) => res?.data?.data);
  };
  const { mutate: reorderWorkSections, isLoading: reorderWorkSectionsLoading } =
    useMutation(reorderWorkSectionApi);

  return {
    workSection,
    refetchWorkSection,
    workSectionLoading,
    createWorkSection,
    createWorkSectionLoading,
    updateWorkSection,
    updateWorkSectionLoading,
    deleteWorkSection,
    deleteWorkSectionLoading,
    reorderWorkSections,
    reorderWorkSectionsLoading,
  };
};
export default useWorkSection;
